export default __webpack_public_path__ + "static/media/MDV_C__0005_Layer-1.6281709a.png";